export default "__VITE_ASSET__6xeW3BO2__"